import Observer from 'common/scripts/observer';
import SearchContent from 'components/search-content';
import ShowMore from 'components/show-more';
import Tags from 'components/tags';
import Years from 'components/years';

const observer = new Observer();

const newsList = document.querySelector('.j-news-list');
const newsMore = document.querySelector('.j-news-more-btn');
const newsURL = newsMore ? newsMore.dataset.more : '';

const newsYearButton = document.querySelector('.j-years-button');
const newsYears = newsYearButton ?
    document.querySelector(`#${newsYearButton.dataset.href}`) :
    document.querySelector('#years');

const searchWrapper = document.querySelector('.j-search-wrapper');
const newsSearchMobile = document.querySelector('.j-search-mobile');
const searchField = document.querySelector('.j-search-field');

const showMoreOptions = {
    page              : 'news',
    button            : newsMore,
    listWrapper       : newsList,
    itemClass         : '.j-news-card',
    nodesAfterLastItem: 1,
    url               : newsURL,
    yearsList         : newsYears,
    yearsItem         : '.j-years-item',
    searchField
};

if (newsList) {
    const loadBtnCount = 1;

    observer.publish('loadProgress', newsList, newsList.childElementCount - loadBtnCount);
}

if (newsMore) {
    new ShowMore(showMoreOptions).init();
}

const newsTagShow = document.querySelector('.j-news-show-tag');
const newsTagsList = document.querySelector('.j-news-list-tags');
const newsTagsURL = newsTagShow ? newsTagShow.dataset.url : '';

const tagsOptions = {
    button        : newsTagShow,
    moreButton    : newsMore,
    listWrapper   : newsTagsList,
    itemClass     : '.j-news-tag',
    contentWrapper: newsList,
    page          : 'news',
    url           : newsTagsURL,
    method        : 'string'
};

if (newsTagsList) {
    new Tags(tagsOptions).init();
}

const yearsURL = newsYearButton ? newsYearButton.dataset.url : '';
const yearsOptions = {
    button        : newsYearButton,
    wrapper       : newsYears,
    moreButton    : newsMore,
    itemClass     : '.j-years-item',
    contentWrapper: newsList,
    page          : 'news',
    url           : yearsURL,
    tags          : newsTagsList,
    tagsItem      : '.j-news-tag',
    search        : searchWrapper,
    searchField   : '.j-search-field'
};

if (newsYears) {
    new Years(yearsOptions).init();
}


const searchOptions = {
    openBtn       : newsSearchMobile,
    tagsList      : newsTagsList,
    moreButton    : newsMore,
    wrapper       : searchWrapper,
    contentWrapper: newsList,
    page          : 'news',
    tags          : newsTagsList,
    tagsItem      : '.j-news-tag',
    years         : newsYears,
    yearsItem     : '.j-years-item'
};

if (searchWrapper) {
    const newsSearch = new SearchContent(searchOptions);

    newsSearch.init();
}

